import { CloseOutlined, PictureOutlined } from "@ant-design/icons";
import { Button, Drawer } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IngredientPhotoList } from "./IngredientPhotoList.tsx";

export const ComparePhotosButton = () => {
  const { t } = useTranslation();
  const [comparing, setComparing] = useState(false);

  return (
    <>
      <Button
        color="primary"
        icon={comparing ? <CloseOutlined /> : <PictureOutlined />}
        onClick={() => setComparing((c) => !c)}
        variant="outlined"
      >
        {t("ingredients.comparePhotos.open")}
      </Button>
      <Drawer
        defaultSize="50%"
        destroyOnHidden
        mask={false}
        onClose={() => setComparing(false)}
        open={comparing}
        placement="right"
        resizable
        title={t("ingredients.comparePhotos.drawerTitle")}
      >
        <IngredientPhotoList />
      </Drawer>
    </>
  );
};
